import * as React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  useGetDeclinedJobCardsQuery,
  useEditRedoInstallMutation,
  useAddChangeLogMutation,
} from "../api/apiSlice";
import { setsteps, setCurrentStep } from "./Stepper/stepperSlice";
import { Nav } from "../QE/Nav/Elements";

function TopNav() {
  return (
    <Box sx={{ mb: 10 }}>
      <Nav style={{ background: "#12131A", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <br />
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={2} align="center" sx={{ ml: 2 }}>
            <Backbutton />
          </Grid>
          <Grid item xs={8} align="left" sx={{ color: "#fff", fontWeight: 600 }}>
            Alerts
          </Grid>
        </Grid>
      </Nav>
    </Box>
  );
}

export default function Alerts() {
  const { data: job_card_data, isSuccess: isGetJobCardDeclinedSuccess } =
    useGetDeclinedJobCardsQuery();

  if (isGetJobCardDeclinedSuccess) {
    return (
      <Grid container alignItems="center" justifyContent="flex-start" sx={{ mt: 10 }}>
        <TopNav />
        <DeclinedList data={job_card_data.job_cards} />
      </Grid>
    );
  } else return null;
}

function resumeToStep(item, navigate, dispatch) {
  const targetState = item.qe_decline_resume_from;
  const ref = item.reference_id;
  const sn = item.serial_number || "";
  const imsi = item.imsi_number || "";
  const archSn = item.archived_serial_number || "";
  const archImsi = item.archived_imsi_number || "";

  if (item.install_state === "NEW") {
    dispatch(setsteps([0, 1, 2, 3, 4, 5]));
    if (targetState === "QRC") {
      dispatch(setCurrentStep(1));
      navigate(`/installer/${ref}/qrcode/`);
    } else if (targetState === "BEFWA" || targetState === "BEF") {
      dispatch(setCurrentStep(2));
      navigate(`/installer/${ref}/${sn}/${imsi}/work_area_before_install/`);
    } else if (targetState === "AMP") {
      dispatch(setCurrentStep(3));
      navigate(`/installer/${ref}/${sn}/${imsi}/connection_test_interlude/`);
    } else if (targetState === "TES") {
      dispatch(setCurrentStep(4));
      navigate(`/installer/${ref}/${sn}/${imsi}/connection_test/`);
    } else if (targetState === "AFT" || targetState === "AFTWA") {
      dispatch(setCurrentStep(5));
      navigate(`/installer/${ref}/${sn}/${imsi}/after_install/`);
    } else {
      navigate("/installer/");
    }
  } else if (item.install_state === "UN") {
    dispatch(setsteps([0, 1, 2, 3]));
    if (targetState === "BEFWA" || targetState === "BEF") {
      dispatch(setCurrentStep(1));
      navigate(`/installer/${ref}/${archSn}/${archImsi}/work_area_before_install/`);
    } else if (targetState === "UNI") {
      dispatch(setCurrentStep(2));
      navigate(`/installer/${ref}/${archSn}/${archImsi}/UN/`);
    } else if (targetState === "AFT" || targetState === "AFTWA") {
      dispatch(setCurrentStep(3));
      navigate(`/installer/${ref}/${archSn}/${archImsi}/after_install/`);
    } else {
      navigate("/installer/");
    }
  } else if (item.install_state === "RE") {
    dispatch(setsteps([0, 1, 2, 3, 4, 5, 6, 7]));
    if (targetState === "BEFWA" || targetState === "BEF") {
      dispatch(setCurrentStep(1));
      navigate(`/installer/${ref}/${archSn}/${archImsi}/work_area_before_install/`);
    } else if (targetState === "UNI") {
      dispatch(setCurrentStep(2));
      navigate(`/installer/${ref}/${archSn}/${archImsi}/RE/`);
    } else if (targetState === "QRCRE") {
      dispatch(setCurrentStep(3));
      navigate(`/installer/${ref}/qrcode/replacement/`);
    } else if (targetState === "DET") {
      dispatch(setCurrentStep(4));
      navigate(`/installer/${ref}/${sn}/${imsi}/details/`);
    } else if (targetState === "AMP") {
      dispatch(setCurrentStep(5));
      navigate(`/installer/${ref}/${sn}/${imsi}/connection_test_interlude/`);
    } else if (targetState === "TES") {
      dispatch(setCurrentStep(6));
      navigate(`/installer/${ref}/${sn}/${imsi}/connection_test/`);
    } else if (targetState === "AFT" || targetState === "AFTWA") {
      dispatch(setCurrentStep(7));
      navigate(`/installer/${ref}/${sn}/${imsi}/after_install/`);
    } else {
      navigate("/installer/");
    }
  } else {
    navigate("/installer/");
  }
}

function DeclinedList({ data }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentItem, setCurrentItem] = React.useState(null);
  const [redoInstall, { isSuccess: isRedoSuccess }] = useEditRedoInstallMutation();
  const [addChangeLog, { isSuccess: addChangeLogSuccess }] = useAddChangeLogMutation();

  React.useEffect(() => {
    if (addChangeLogSuccess && currentItem) {
      redoInstall({ body: { job_card_id: currentItem.id } });
    }
  }, [addChangeLogSuccess]);

  const handleReinstall = (item) => {
    setCurrentItem(item);
    const sn = item.install_state !== "UN" ? item.serial_number : item.archived_serial_number;
    addChangeLog({
      body: {
        serial_number: sn,
        change:
          item.install_state !== "UN"
            ? "Installer is redoing declined install"
            : "Installer is redoing declined uninstall",
      },
    });
  };

  React.useEffect(() => {
    if (isRedoSuccess && currentItem) {
      resumeToStep(currentItem, navigate, dispatch);
    }
  }, [isRedoSuccess]);

  if (data.length === 0) {
    return (
      <Grid container alignItems="center" justifyContent="center" sx={{ mt: 5 }}>
        <Typography sx={{ fontSize: 20, color: "rgba(255,255,255,0.5)" }}>
          No alerts
        </Typography>
      </Grid>
    );
  }

  return data.map((item) => (
    <React.Fragment key={item.id}>
      <Grid item xs={0.5} />
      <Grid item xs={11}>
        <Box
          sx={{
            backgroundColor: "#161B22",
            border: "1px solid rgba(255,255,255,0.07)",
            borderRadius: "12px",
            p: 2,
            mb: 1.5,
          }}
        >
          {/* Header row */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <WarningAmberIcon sx={{ color: "#ef4444", fontSize: 18 }} />
              <Typography sx={{ color: "#ef4444", fontSize: "0.85rem", fontWeight: 700 }}>
                Install Approval Declined
              </Typography>
            </Box>
            <Typography
              sx={{
                backgroundColor: "rgba(255,255,255,0.06)",
                color: "rgba(255,255,255,0.55)",
                fontSize: "0.7rem",
                px: 1,
                py: 0.4,
                borderRadius: "6px",
                fontFamily: "monospace",
              }}
            >
              {item.reference_id || `JC-${item.id}`}
            </Typography>
          </Box>

          {/* Install Date */}
          <Box sx={{ mb: 1 }}>
            <Typography
              sx={{
                fontSize: "0.62rem",
                color: "rgba(255,255,255,0.35)",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                mb: 0.25,
              }}
            >
              Install Date
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", color: "#fff" }}>
              {item.installation_date}
            </Typography>
          </Box>

          {/* Address */}
          <Box sx={{ mb: 1 }}>
            <Typography
              sx={{
                fontSize: "0.62rem",
                color: "rgba(255,255,255,0.35)",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                mb: 0.25,
              }}
            >
              Address
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", color: "#fff" }}>
              {item.address}
            </Typography>
          </Box>

          {/* Reason */}
          <Box sx={{ mb: 1.5 }}>
            <Typography
              sx={{
                fontSize: "0.62rem",
                color: "rgba(255,255,255,0.35)",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                mb: 0.25,
              }}
            >
              Reason
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", color: "#fff" }}>
              {item.qe_decline_reason}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={() => handleReinstall(item)}
              variant="contained"
              sx={{
                backgroundColor: "#FDB940",
                color: "#000",
                fontWeight: 700,
                borderRadius: "8px",
                px: 2.5,
                "&:hover": { backgroundColor: "#e6a832" },
              }}
            >
              Reinstall
            </Button>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={0.5} />
    </React.Fragment>
  ));
}

function Backbutton() {
  const navigate = useNavigate();
  return (
    <ArrowBackIcon
      onClick={() => navigate(-1)}
      sx={{ color: "#fff", cursor: "pointer" }}
    />
  );
}
